<template>  
  <div class="resSucess"> 
  </div>
</template>

<script>
export default {
  name: 'resSucess',
  data () {
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
  
</style>



// WEBPACK FOOTER //
// src/components/content/resSucess.vue